import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/@shared/shared/shared.module';
import { AuthGuard } from 'src/@shared/shared/auth.guard';
import { SwitchAcComponent } from './switch-ac/switch-ac.component';
import { ProfileMenuModule } from './pages/common-layout/account-settings/profile-menu/profile-menu.module';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { CodeInputModule } from 'angular-code-input';
import { SiteUnderMaintenanceComponent } from './site-under-maintenance/site-under-maintenance.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NzModalModule } from 'ng-zorro-antd/modal';
import * as Sentry from '@sentry/angular';
import { AuthInterceptorService } from './auth-interceptor.service';

registerLocaleData(en);

@NgModule({ declarations: [
        AppComponent,
        SwitchAcComponent,
        ErrorpageComponent,
        SiteUnderMaintenanceComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        MatDatepickerModule,
        AppRoutingModule,
        ProfileMenuModule,
        MatInputModule,
        FormsModule,
        BrowserAnimationsModule,
        MatNativeDateModule,
        SharedModule,
        CodeInputModule,
        NzModalModule], providers: [
        AuthGuard,
        { provide: NZ_I18N, useValue: en_US },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({ showDialog: false }),
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
  constructor() {}
}
